import { Navigate, Route, Routes } from "react-router-dom";
import { AuthProvider } from "./auth/AuthContext";
import { RequireAuth } from "./auth/RequireAuth";
import { RequireBackOffice } from "./auth/RequireBackOffice";
import { LandingRedirect } from "./auth/LandingRedirect";
import { ShellLayout } from "./layout/ShellLayout";
import { ForgotPasswordView } from "./views/Auth/ForgotPasswordView";
import { LoginView } from "./views/Auth/LoginView";
import { ResetPasswordView } from "./views/Auth/ResetPasswordView";
import { DashboardView } from "./views/Dashboard/DashboardView";
import { TesourariaView } from "./views/Tesouraria/TesourariaView";
import { BancosView } from "./views/Bancos/BancosView";
import { MovimentosBancariosView } from "./views/MovimentosBancarios/MovimentosBancariosView";
import { ReconciliacaoBancariaView } from "./views/ReconciliacaoBancaria/ReconciliacaoBancariaView";
import { TarefasView } from "./views/Tarefas/TarefasView";
import { ConciliacaoFiscalView } from "./views/ConciliacaoFiscal/ConciliacaoFiscalView";
import { ConfirmingView } from "./views/Confirming/ConfirmingView";
import { ContasReceberView } from "./views/ContasReceber/ContasReceberView";
import { ClientesView } from "./views/Clientes/ClientesView";
import { OrcamentosView } from "./views/Orcamentos/OrcamentosView";
import { CriarOrcamentoView } from "./views/Orcamentos/CriarOrcamentoView";
import { EditarOrcamentoView } from "./views/Orcamentos/EditarOrcamentoView";
import { ObrasView } from "./views/Obras/ObrasView";
import { EditarObraView } from "./views/Obras/EditarObraView";
import { CampoObrasView } from "./views/Campo/CampoObrasView";
import { CampoObraView } from "./views/Campo/CampoObraView";
import { FolhaDeHorasView } from "./views/FolhaDeHoras/FolhaDeHorasView";
import { FornecedoresView } from "./views/Fornecedores/FornecedoresView";
import { NotificacoesView } from "./views/Notificacoes/NotificacoesView";
import { PerfilView } from "./views/Perfil/PerfilView";
import { GestaoAcessosView } from "./views/Acessos/GestaoAcessosView";
import { UtilizadoresView } from "./views/Utilizadores/UtilizadoresView";
import { NovoUtilizadorView } from "./views/Utilizadores/NovoUtilizadorView";
import { EditarUtilizadorView } from "./views/Utilizadores/EditarUtilizadorView";
import { NovoClienteView } from "./views/Clientes/NovoClienteView";
import { EditarClienteView } from "./views/Clientes/EditarClienteView";
import { NovoFornecedorView } from "./views/Fornecedores/NovoFornecedorView";
import { EditarFornecedorView } from "./views/Fornecedores/EditarFornecedorView";
import { SubempreiteirosView } from "./views/Subempreiteiros/SubempreiteirosView";
import { NovoSubempreiteiroView } from "./views/Subempreiteiros/NovoSubempreiteiroView";
import { EditarSubempreiteiroView } from "./views/Subempreiteiros/EditarSubempreiteiroView";
import { InquilinosView } from "./views/Inquilinos/InquilinosView";
import { NovoInquilinoView } from "./views/Inquilinos/NovoInquilinoView";
import { EditarInquilinoView } from "./views/Inquilinos/EditarInquilinoView";
import { ImoveisView } from "./views/Imoveis/ImoveisView";
import { NovoImovelView } from "./views/Imoveis/NovoImovelView";
import { EditarImovelView } from "./views/Imoveis/EditarImovelView";
import { ArrendamentosView } from "./views/Arrendamentos/ArrendamentosView";
import { NovoArrendamentoView } from "./views/Arrendamentos/NovoArrendamentoView";
import { EditarArrendamentoView } from "./views/Arrendamentos/EditarArrendamentoView";
import { RendasView } from "./views/Rendas/RendasView";
import { RecibosView } from "./views/Recibos/RecibosView";
import { RelatoriosView } from "./views/Relatorios/RelatoriosView";
import { DocumentosView } from "./views/Documentos/DocumentosView";
import { ArmazensView } from "./views/Armazens/ArmazensView";
import { NovoArmazemView } from "./views/Armazens/NovoArmazemView";
import { EditarArmazemView } from "./views/Armazens/EditarArmazemView";
import { GlossarioView } from "./views/Glossario/GlossarioView";
import { NovoTermoView } from "./views/Glossario/NovoTermoView";
import { EditarTermoView } from "./views/Glossario/EditarTermoView";
import { CatalogoView } from "./views/Catalogo/CatalogoView";
import { WorkTypeTemplateView } from "./views/Catalogo/WorkTypeTemplateView";
import { FaturasView } from "./views/Faturas/FaturasView";
import { FaturasReceitasView } from "./views/Faturas/FaturasReceitasView";
import { ResumoFinanceiroView } from "./views/Resumo/ResumoFinanceiroView";
import { ImportacoesEmailView } from "./views/Faturas/ImportacoesEmailView";
import { EmprestimosView } from "./views/Emprestimos/EmprestimosView";
import { NovoEmprestimoView } from "./views/Emprestimos/NovoEmprestimoView";
import { EditarEmprestimoView } from "./views/Emprestimos/EditarEmprestimoView";
import { AuditoriaView } from "./views/Auditoria/AuditoriaView";
import { TrabalhadoresView } from "./views/Trabalhadores/TrabalhadoresView";
import { NovoTrabalhadorView } from "./views/Trabalhadores/NovoTrabalhadorView";
import { EditarTrabalhadorView } from "./views/Trabalhadores/EditarTrabalhadorView";
import { PlaceholderView } from "./views/Placeholder/PlaceholderView";

export default function App() {
  return (
    <AuthProvider>
      <Routes>
        <Route element={<ShellLayout />}>
          <Route path="auth">
            <Route index element={<Navigate to="login" replace />} />
            <Route path="login" element={<LoginView />} />
            <Route
              path="forgot-password"
              element={<ForgotPasswordView />}
            />
            <Route
              path="reset-password"
              element={<ResetPasswordView />}
            />
          </Route>

          <Route element={<RequireAuth />}>
            <Route index element={<LandingRedirect />} />
            {/* Rotas abertas à equipa interna (papel TeamMember). */}
            <Route path="folha-de-horas" element={<FolhaDeHorasView />} />
            <Route path="notificacoes" element={<NotificacoesView />} />
            <Route path="perfil" element={<PerfilView />} />
            {/* Back-office — vedado à equipa interna; cai na Folha de Horas. */}
            <Route element={<RequireBackOffice />}>
            <Route path="dashboard" element={<DashboardView />} />
            <Route path="tarefas" element={<TarefasView />} />
            <Route path="tesouraria" element={<TesourariaView />} />
            <Route path="bancos" element={<BancosView />} />
            <Route path="movimentos-bancarios" element={<MovimentosBancariosView />} />
            <Route path="reconciliacao-bancaria" element={<ReconciliacaoBancariaView />} />
            <Route path="conciliacao-fiscal" element={<ConciliacaoFiscalView />} />
            <Route path="confirming" element={<ConfirmingView />} />
            <Route path="contas-a-receber" element={<ContasReceberView />} />
            <Route path="orcamentos" element={<OrcamentosView />} />
            <Route
              path="orcamentos/novo"
              element={<CriarOrcamentoView />}
            />
            <Route
              path="orcamentos/editar/:budgetId"
              element={<EditarOrcamentoView />}
            />
            <Route path="obras" element={<ObrasView />} />
            <Route path="obras/:workId" element={<EditarObraView />} />
            <Route path="campo" element={<CampoObrasView />} />
            <Route path="campo/:workId" element={<CampoObraView />} />
            <Route path="clientes" element={<ClientesView />} />
            <Route path="clientes/novo" element={<NovoClienteView />} />
            <Route
              path="clientes/editar/:clientId"
              element={<EditarClienteView />}
            />
            <Route path="fornecedores" element={<FornecedoresView />} />
            <Route
              path="fornecedores/novo"
              element={<NovoFornecedorView />}
            />
            <Route
              path="fornecedores/editar/:supplierId"
              element={<EditarFornecedorView />}
            />
            <Route
              path="subempreiteiros"
              element={<SubempreiteirosView />}
            />
            <Route
              path="subempreiteiros/novo"
              element={<NovoSubempreiteiroView />}
            />
            <Route
              path="subempreiteiros/editar/:subcontractorId"
              element={<EditarSubempreiteiroView />}
            />
            <Route path="inquilinos" element={<InquilinosView />} />
            <Route
              path="inquilinos/novo"
              element={<NovoInquilinoView />}
            />
            <Route
              path="inquilinos/editar/:tenantId"
              element={<EditarInquilinoView />}
            />
            <Route path="imoveis" element={<ImoveisView />} />
            <Route
              path="imoveis/novo"
              element={<NovoImovelView />}
            />
            <Route
              path="imoveis/editar/:propertyId"
              element={<EditarImovelView />}
            />
            <Route path="arrendamentos" element={<ArrendamentosView />} />
            <Route
              path="arrendamentos/novo"
              element={<NovoArrendamentoView />}
            />
            <Route
              path="arrendamentos/editar/:contractId"
              element={<EditarArrendamentoView />}
            />
            <Route path="rendas" element={<RendasView />} />
            <Route path="recibos" element={<RecibosView />} />
            <Route path="relatorios" element={<RelatoriosView />} />
            <Route path="documentos" element={<DocumentosView />} />
            <Route path="armazens" element={<ArmazensView />} />
            <Route
              path="armazens/novo"
              element={<NovoArmazemView />}
            />
            <Route
              path="armazens/editar/:warehouseId"
              element={<EditarArmazemView />}
            />
            <Route path="glossario" element={<GlossarioView />} />
            <Route
              path="glossario/novo"
              element={<NovoTermoView />}
            />
            <Route
              path="glossario/editar/:termId"
              element={<EditarTermoView />}
            />
            <Route path="catalogo" element={<CatalogoView />} />
            <Route
              path="catalogo/tipos-obra/:workTypeId"
              element={<WorkTypeTemplateView />}
            />
            <Route path="faturas-receitas" element={<FaturasReceitasView />} />
            <Route path="resumo-financeiro" element={<ResumoFinanceiroView />} />
            <Route path="faturas" element={<FaturasView />} />
            <Route path="importacoes-email" element={<ImportacoesEmailView />} />
            <Route path="emprestimos" element={<EmprestimosView />} />
            <Route
              path="emprestimos/novo"
              element={<NovoEmprestimoView />}
            />
            <Route
              path="emprestimos/editar/:loanId"
              element={<EditarEmprestimoView />}
            />
            <Route path="trabalhadores" element={<TrabalhadoresView />} />
            <Route
              path="trabalhadores/novo"
              element={<NovoTrabalhadorView />}
            />
            <Route
              path="trabalhadores/editar/:workerId"
              element={<EditarTrabalhadorView />}
            />
            <Route path="auditoria" element={<AuditoriaView />} />
            <Route path="acessos" element={<GestaoAcessosView />} />
            <Route path="utilizadores" element={<UtilizadoresView />} />
            <Route path="utilizadores/novo" element={<NovoUtilizadorView />} />
            <Route
              path="utilizadores/editar/:userId"
              element={<EditarUtilizadorView />}
            />
            <Route path=":section" element={<PlaceholderView />} />
            </Route>
          </Route>

          <Route path="*" element={<Navigate to="/" replace />} />
        </Route>
      </Routes>
    </AuthProvider>
  );
}
